import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { WORKSHOP_CONFIG } from "../config/workshop";
import "./Nav.css";

function Nav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();

  const allItems = [
    { path: "/", label: t("nav.home") },
    { path: "/what", label: t("nav.what") },
    { path: "/why", label: t("nav.why") },
    { path: "/how", label: t("nav.getStarted") },
    { path: "/who", label: t("nav.who") },
    { path: "/when", label: t("nav.when") }
  ];

  const menuItems = allItems.filter((item) => {
    if (item.path === "/who") return WORKSHOP_CONFIG.showWho !== false;
    if (item.path === "/when") return WORKSHOP_CONFIG.showWhen !== false;
    return true;
  });

  const handleNavClick = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  return (
    <>
      <button 
        className="menu-toggle"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle menu"
      >
        <span className={`hamburger ${isMenuOpen ? "open" : ""}`}>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>
      
      <nav className={`nav ${isMenuOpen ? "open" : ""}`}>
        <ul className="nav-list">
          {menuItems.map((item) => (
            <li
              key={item.path}
              onClick={() => handleNavClick(item.path)}
              className={location.pathname === item.path ? "active" : ""}
            >
              {item.label}
            </li>
          ))}
        </ul>
      </nav>
      
      <div 
        className={`menu-overlay ${isMenuOpen ? "active" : ""}`} 
        onClick={() => setIsMenuOpen(false)}
      ></div>
    </>
  );
}

export default Nav;
